import React from 'react';
import profileImage from '../images/Picsart_22-12-10_15-41-40-018.jpg'

const About = () => {
    return (
        <div id='about'>
            <section id="about" className="mx-5">
                <div className="container">

                    <div className="section-title">
                        <h4 className='text-2xl font-bold'>About</h4>
                        <p >Hello, my name is Shakil Khan. At the moment, I'm pursuing a
                            B.Sc. in Electrical
                            and
                            Electronics
                            Engineering at Barisal
                            Engineering College. I'm also a newbie web developer. I'm currently learning with Programming Hero. My
                            mission is to
                            achieve my ambition of becoming a web developer.</p>
                    </div>

                    <div className="row flex mt-10 lg:flex-row flex-col items-center justify-center">
                        <div className="col-lg-4" data-aos="fade-right">
                            <img src={profileImage} className="img-fluid rounded-3xl border w-44 md:mr-4 mr-0 lg:mr-10" alt="" />
                        </div>
                        <div className="col-lg-8 pt-4 pt-lg-0 content" data-aos="fade-left">
                            <h3 className='text-3xl' >MERN stack developer</h3>

                            <div className="row">
                                <div className="col-lg-6 mt-3">
                                    <ul className='text-center space-y-2'>
                                        <li><i className="bi bi-chevron-right"></i> <strong className='text-yellow-600'>Birthday:</strong> <span>29 November 2000</span></li>

                                        <li><i className="bi bi-chevron-right"></i> <strong className='text-yellow-600'>Phone:</strong> <span>+8801631226960</span></li>
                                        <li><i className="bi bi-chevron-right"></i> <strong className='text-yellow-600'>City:</strong> <span>Barisal, Bangladesh</span></li>
                                    </ul>
                                </div>
                                <div className="col-lg-6">
                                    <ul className='text-center space-y-2'>
                                        <li><i className="bi bi-chevron-right"></i> <strong className='text-yellow-600'>Age:</strong> <span>21</span></li>
                                        <li><i className="bi bi-chevron-right"></i> <strong className='text-yellow-600'>Degree:</strong> <span>Currently studying
                                            B.Sc in EEE</span></li>
                                        <li><i className="bi bi-chevron-right"></i> <strong className='text-yellow-600'>Email:</strong>
                                            <span>shakilkhan496@gmail.com</span>
                                        </li>
                                        <li><i className="bi bi-chevron-right"></i> <strong className='text-yellow-600'>Freelance:</strong> <span>Available</span></li>
                                    </ul>
                                </div>
                            </div>

                        </div>
                    </div>

                </div>
            </section>
        </div>
    );
};

export default About;